import { Grid } from '@material-ui/core';
import { Ticketing } from '@nemuru-eng/js-api-client';

import { ActivitySummaryCard } from '@/components/widgets/CustomerSupport/components/CustomerSupportDialog/components/CustomerSupportHeader/components/ActivitySummaryCard';
import { ActivityCardVariant } from '@/components/widgets/CustomerSupport/components/CustomerSupportDialog/components/CustomerSupportHeader/types/ActivityCardVariant';

interface ActivitySummaryProps {
  ticketing: Ticketing;
  loanId: string;
}

export const ActivitySummary = ({ ticketing, loanId }: ActivitySummaryProps) => {
  return (
    <Grid spacing={2} container style={{ paddingBottom: '32px' }}>
      {Object.values(ActivityCardVariant).map((variant) => (
        <Grid item xs={4}>
          <ActivitySummaryCard loanId={loanId} variant={variant} ticketing={ticketing} />
        </Grid>
      ))}
    </Grid>
  );
};
